import betterwe from '@/common/app-common.js'
const shareData = [
  {
    title: '保存图片',
    data: [
      {
        icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon1',
        name: '保存到手机',
        id: 1,
        func: 'saveImageToPhone',
        close: true
      },
      {
        icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon2',
        name: '微信好友',
        id: 2,
        func: 'saveImageToWxFriend',
        close: true
      },
      {
        icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon3',
        name: '朋友圈',
        id: 3,
        func: 'saveImageToWxCircle',
        close: true
      }
    ]
  },
  {
    title: '复制链接',
    data: [
      {
        icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon5',
        name: '生成分享图',
        id: 4,
        func: 'createPoster',
        close: false
      },
      {
        icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon2',
        name: '微信好友',
        id: 5,
        func: 'copyLinkToWxFriend',
        close: true
      },
      {
        icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon3',
        name: '朋友圈',
        id: 6,
        func: 'copyLinkToWxCircle',
        close: true
      },
      {
        icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon4',
        name: '复制链接',
        id: 7,
        func: 'copyLinkToClipboard',
        close: true
      }
    ]
  }
]
//分享到微信
const shareWechat = (obj) => {
  betterwe.onAppShare(obj)
}
const eventObj = {
  //保存图片到手机
  saveImageToPhone: function (self) {
    betterwe.onAppSaveImage({
      data: self.imgUrl, //分享的具体数据
      //分享的数据的格式
      //type=base64  表示图片格式是base64   type=url  表示图片格式是链接
      type: 'base64'
    })
  },
  saveImageToWxFriend: function (self) {
    let obj = {
      shareType: 1, //分享的类型 1 微信好友 2 微信朋友圈
      contentType: 'image', //分享的数据类型  image 分享图片  url 分享H5链接
      // 分享的数据
      shareData: {
        data: self.imgUrl, //分享的链接
        //分享的数据的格 式
        //contentType为image的情况下, type=base64  表示图片格式是base64   type=url  表示图片格式是链接
        type: 'base64',
        desc: self.shareOptions.desc,
        title: self.shareOptions.title,
        thumbnail: self.shareOptions.thumbnail // 分享的缩略图的url
      }
    }
    shareWechat(obj)
  },
  saveImageToWxCircle: function (self) {
    let obj = {
      shareType: 2, //分享的类型 1 微信好友 2 微信朋友圈
      contentType: 'image', //分享的数据类型  image 分享图片  url 分享H5链接
      // 分享的数据
      shareData: {
        data: self.imgUrl, //分享的链接
        //分享的数据的格 式
        //contentType为image的情况下, type=base64  表示图片格式是base64   type=url  表示图片格式是链接
        type: 'base64',
        desc: self.shareOptions.desc,
        title: self.shareOptions.title,
        thumbnail: self.shareOptions.thumbnail // 分享的缩略图的url
      }
    }
    shareWechat(obj)
  },
  //生成海报
  createPoster: function (self) {
    self.createPoster(self.posterId)
  },
  copyLinkToWxFriend: function (self) {
    let obj = {
      shareType: 1, //分享的类型 1 微信好友 2 微信朋友圈
      contentType: 'url', //分享的数据类型  image 分享图片  url 分享H5链接
      // 分享的数据
      shareData: {
        data: self.copyUrl, //分享的链接
        //分享的数据的格 式
        //contentType为image的情况下, type=base64  表示图片格式是base64   type=url  表示图片格式是链接
        type: 'url',
        desc: self.shareOptions.desc,
        title: self.shareOptions.title,
        thumbnail: self.shareOptions.thumbnail // 分享的缩略图的url
      }
    }
    shareWechat(obj)
  },
  copyLinkToWxCircle: function (self) {
    let obj = {
      shareType: 2, //分享的类型 1 微信好友 2 微信朋友圈
      contentType: 'url', //分享的数据类型  image 分享图片  url 分享H5链接
      // 分享的数据
      shareData: {
        data: self.copyUrl, //分享的链接
        //分享的数据的格 式
        //contentType为image的情况下, type=base64  表示图片格式是base64   type=url  表示图片格式是链接
        type: 'url',
        desc: self.shareOptions.desc,
        title: self.shareOptions.title,
        thumbnail: self.shareOptions.thumbnail // 分享的缩略图的url
      }
    }
    shareWechat(obj)
  },
  copyLinkToClipboard: function () {}
}
export { shareData, eventObj }
